import { ImageData, OptimizedImage } from '../optimized-image/optimized-image';
import clsx from 'clsx';

import warning from 'assets/png/warning.png?format=webp;avif&as=picture';
import XIcon from 'assets/svg/close-x.svg?react';

interface InfoModalProps {
  title?: string;
  children: React.ReactNode;
  onClose?: () => void;
  image?: ImageData;
  className?: string;
}

export const InfoModal = ({
  onClose,
  title,
  children,
  image = warning,
  className = '',
}: InfoModalProps) => {
  return (
    <div
      className={clsx(
        'fixed bottom-0 left-0 right-0 top-0 z-50 flex h-full w-full items-center justify-center',
        className,
      )}
    >
      <div
        className="mx-auto max-w-[90%] rounded-3xl p-0.5"
        style={{
          background: `linear-gradient(
              180deg,
               rgba(110, 72, 0, 1) 0%,
      rgba(29, 33, 62, 1) 100%
            )`,
        }}
      >
        <div
          className="relative flex max-w-[360px] flex-col overflow-hidden rounded-3xl bg-grape p-4 md:p-6"
          style={{
            background: `linear-gradient(
              180deg,
              rgba(84, 57, 42, 1) 0%,
              rgba(16, 14, 52, 1) 100%
            )`,
          }}
        >
          {onClose && (
            <XIcon
              className="absolute right-5 top-5 cursor-pointer text-blue-border"
              onClick={onClose}
            />
          )}

          <OptimizedImage
            imageData={image}
            alt="warning"
            className="z-50 mx-auto mb-4 w-20 md:mb-6 md:w-[152px]"
          />
          <div
            className="relative mb-4 flex items-center justify-center text-center text-xl font-bold leading-[44px] md:mb-6 md:text-4xl"
            style={{
              background: `linear-gradient(
              118.73deg,
              rgba(255, 255, 255, 1) 0%,
              rgba(255, 192, 0, 1) 100%
            )`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {title}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
